import { Modal } from '@mi-front/ui';
import React, { useEffect, useState } from 'react';
import mime from 'mime';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import { useUrlMediaPlayerCtx } from './useUrlMediaPlayer';
import { VideoJSNoContext } from '../video-player/VideoJsNoContext';
import { IconButton } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

/**
 * Simple video/audio media player that requires only a URL and a
 * media type. The media player will be shown in a closable modal.
 */
export function UrlMediaPlayer() {
  const [show, setShow] = useState(false);
  const ctx = useUrlMediaPlayerCtx();

  useEffect(() => {
    setShow(!!ctx.url);
  }, [ctx.url]);

  let player: React.ReactNode = null;

  if (ctx.url) {
    const type = ctx.options.type ?? mime.getType(ctx.url);

    if (!type) {
      player = 'No player found for type';
    } else if (type.startsWith('audio/')) {
      player = (
        <audio autoPlay controls style={{ width: '100%' }}>
          <source src={ctx.url} type={type} />
        </audio>
      );
    } else if (type.startsWith('video/')) {
      player = (
        <VideoJSNoContext
          options={{
            autoplay: true,
            controls: true,
            sources: [
              {
                src: ctx.url,
                type,
              },
            ],
            controlBar: {
              pictureInPictureToggle: false,
            },
          }}
        />
      );
    }
  }

  return (
    <Modal
      show={show}
      width="50rem"
      closeOnOutsideClick
      onHide={() => ctx.reset()}
      showCloseButton
      actions={
        <IconButton
          sx={{ padding: 0 }}
          onClick={() => {
            window.open(`${ctx.url}&download=1`, '_blank');
          }}
        >
          <DownloadIcon fontSize={'small'} />
        </IconButton>
      }
      title={
        ctx.options?.title ? (
          <div>
            <OndemandVideoIcon /> {ctx.options?.title}
          </div>
        ) : null
      }
    >
      {player}
    </Modal>
  );
}
